import React from 'react';

export function Section({ id, title, children }) {
  return (
    <section id={id} className="max-w-4xl mx-auto my-16 px-6">
      <h2 className="text-3xl font-bold mb-6 text-center text-primary">{title}</h2>
      <div className="prose prose-lg mx-auto text-gray-700">
        {children}
      </div>
    </section>
  );
}
